// Environment configuration utility
// This utility provides access to environment variables from window._env_ (production)
// or process.env (development)

const getEnvVar = (key, defaultValue = null) => {
  // In production, use window._env_ which is populated by startup.sh
  if (typeof window !== 'undefined' && window._env_) {
    return window._env_[key] || defaultValue;
  }
  
  // In development, fallback to process.env
  if (typeof process.env !== 'undefined' && process.env) {
    return process.env[key] || defaultValue;
  }
  return defaultValue;
};

export const env = {  //for prod
  REACT_APP_CLIENT_ID: getEnvVar('REACT_APP_CLIENT_ID'),
  REACT_APP_TENANT_ID: getEnvVar('REACT_APP_TENANT_ID'), 
  REACT_APP_WS_API: getEnvVar('REACT_APP_WS_API'),
  REACT_APP_BACKEND_APP_NAME: getEnvVar('REACT_APP_BACKEND_APP_NAME'),
  REACT_APP_REDIRECT_URL: getEnvVar('REACT_APP_REDIRECT_URL'),
  REACT_APP_ADMIN_GROUP_ID: getEnvVar('REACT_APP_ADMIN_GROUP_ID'),
  REACT_APP_USERS_GROUP_ID: getEnvVar('REACT_APP_USERS_GROUP_ID'),
  REACT_APP_CONFIG_GROUP: getEnvVar('REACT_APP_CONFIG_GROUP'),
  REACT_APP_OCR_API: getEnvVar('REACT_APP_OCR_API'),
  REACT_APP_APPINSIGHTS_CONNECTION_STRING: getEnvVar('REACT_APP_APPINSIGHTS_CONNECTION_STRING'),
  REACT_APP_STORAGE_ACCOUNT: getEnvVar('REACT_APP_STORAGE_ACCOUNT'),
  REACT_APP_KV_CONN_STRING: getEnvVar('REACT_APP_KV_CONN_STRING'),
  REACT_APP_FABRIC_WORKSPACE: getEnvVar('REACT_APP_FABRIC_WORKSPACE'),
  REACT_APP_DOCUMENT_LAKEHOUSE_NAME: getEnvVar('REACT_APP_DOCUMENT_LAKEHOUSE_NAME'),
  REACT_APP_REQUIRE_ACCESS_CODE: getEnvVar('REACT_APP_REQUIRE_ACCESS_CODE'),
};

// App setting flag: true (default) gates chat behind /login exactly as before;
// false makes chat public by default with a silently-issued guest token.
export const requireAccessCode = env.REACT_APP_REQUIRE_ACCESS_CODE !== 'false';

export default getEnvVar;